import React from 'react';
import { THEME } from '../../utils/theme';

const ViewToggle = ({ viewMode, setViewMode, cardSize, setCardSize }) => (
  <div style={{ display: 'flex', gap: '4px', background: THEME.bg, borderRadius: '10px', padding: '4px', border: `1px solid ${THEME.border}` }}>
    {[
      { mode: 'cards', label: '▦' },
      { mode: 'compact', label: '▤' },
      { mode: 'list', label: '☰' }
    ].map(({ mode, label }) => (
      <button key={mode} onClick={() => setViewMode(mode)} style={{
        background: viewMode === mode ? THEME.bgElevated : 'transparent', color: viewMode === mode ? THEME.text : THEME.textMuted,
        border: 'none', borderRadius: '8px', padding: '10px 16px', fontSize: '16px', cursor: 'pointer', transition: 'all 0.15s'
      }} title={mode.charAt(0).toUpperCase() + mode.slice(1)}>{label}</button>
    ))}
  </div>
);

export default ViewToggle;
